'use strict';

import './sa-info.directive.css';

class SaInfoDirective {
  constructor() {
    'nginject';

    this.restrict = 'E';
    this.template = require('./sa-info.directive.html');
    this.scope = {
      sa: '=',
      show: '='
    }
  }
}

export default angular.module('leptonApp.saInfoDirective', [])
  .directive('saInfoDirective', [() => new SaInfoDirective()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/sa-info/sa-info.directive.js